import type { MutableRefObject, RefObject } from 'react'
import { useOverlay } from '@/shared/lib/overlay/useOverlay'

export interface DialogA11yOptions {
  /** Sem efeito: todo diálogo entra na pilha única (voltar web e nativo). Mantido por compatibilidade. */
  historyBack?: boolean
  /** Sem efeito (ver `useOverlayHistoryBack`). */
  confirmedRef?: MutableRefObject<boolean>
  /** Guarda de descarte (BACK-10): voltar/Esc só fecham se resolver `true`. */
  canDismiss?: () => boolean | Promise<boolean>
  /** `false` = voltar/Esc não fecham e mostram «Aguarde terminar para fechar.» (BACK-13). */
  isDismissible?: () => boolean
}

/** Esc + voltar + foco inicial/restauração — delega para `useOverlay` (mesmo contrato de `ConfirmDialog`). */
export function useDialogA11y(
  open: boolean,
  onClose: () => void,
  initialFocusRef?: RefObject<HTMLElement | null>,
  options?: DialogA11yOptions,
) {
  useOverlay(open, {
    kind: 'dialog',
    onRequestClose: () => onClose(),
    initialFocusRef,
    canDismiss: options?.canDismiss,
    isDismissible: options?.isDismissible,
  })
}
